import WithSuspense from "./with-suspense";

export default WithSuspense